export const img = "/assets/Eastern_University_Banglade.png";
export const mujibLogo = "/assets/mujib_logo.png";

export const img2 = "/assets/slider/Pc/drama_arts_slider.webp";
export const convocation_culture_program =
  "/assets/slider/Pc/convocation_culture_program.webp";

//export const img2 = "/assets/slider/Pc/Computer_Lab(1200x450).webp";

export const img1 = "/assets/slider/Pc/physics_olympiad_2023_EEE.webp";
export const img3 = "/assets/slider/Pc/Campus+Bus.webp";
export const convoction_7th_slider_4 =
  "/assets/slider/Pc/Convocation_GoldMadelist.webp";
//export const img4 = "/assets/slider/Pc/Students+Singing(1200x450).webp";
export const img4 = "/assets/slider/Pc/runnerup_debate_law.webp";
export const img5 = "/assets/slider/Pc/Library(1200x450).webp";

export const img6 = "/assets/slider/Pc/CoronaUpdate1.webp";
export const img7 = "/assets/slider/Pc/Convocation_6th_EU.webp";
export const img8 = "/assets/slider/Pc/CoronaUpdate3.webp";
//export const img9 = "/assets/slider/Pc/CoronaUpdate4.webp";
export const img9 = "/assets/slider/Pc/international_internship.webp";
export const img10 = "/assets/slider/Pc/3D_Permanent_Campus.webp";
export const img11 = "/assets/slider/Pc/Female_Hostel.webp";
export const img12 = "/assets/slider/Pc/admission_slider.webp";

export const img13 = "/assets/slider/Pc/Summer-2023-Permanent-Sanad.webp";

export const slider1 = "/assets/slider/Pc/15-August-2023_WebSlide.webp";

export const convoction_7th_slider_1 =
  "/assets/slider/Pc/top_view_7th_convocation.webp";
export const convoction_7th_slider_2 =
  "/assets/slider/Pc/all_guest_view_7th_convocation.webp";
export const convoction_7th_slider_3 =
  "/assets/slider/Pc/crest_giving_ceremony_7th_convocation.webp";

export const convocation_botMember = "/assets/slider/Pc/botmembers.webp";

export const artImg = "/assets/English.jpg";
export const bussImg = "/assets/Business.jpg";
export const engImg = "/assets/E&T.jpg";
export const lawImg = "/assets/Law.jpg";

export const careerImgFaculty = "/assets/Career/careerFaculty.webp";
export const careerImgAdmin = "/assets/Career/careerAdmin.webp";
export const careerImgOnCampus = "/assets/Career/careerOnCampus.webp";
export const careerImgMLSS = "/assets/Career/careerMLSS.webp";

// Submenu
export const aboutImg = "/assets/BoardMeeting.webp";
export const academicImg = "/assets/Academic.jpg";
export const admissionImg = "/assets/Admission.jpg";
export const contactImg = "/assets/Contact.jpg";
export const communityImg = "/assets/Community.jpg";
export const researchImg = "/assets/Research.jpg";
export const newsAndUpdateImg = "/assets/NewsAndUpdate.jpg";

// About Us
export const Treasurer = "/assets/aboutUs/Treasurer.webp";
export const Registrar = "/assets/aboutUs/Registrar.jpg";
export const proctorImage = "/assets/Faculty/DeanOfEnglishMoniruzzamanArts.jpg";

export const AssistantProctor1 =
  "/assets/aboutUs/AssistantProctorAbdurRob_eng.jpg";
export const AssistantProctor2 =
  "/assets/aboutUs/AssistantProctorMamunur_Law.jpg";
export const AssistantProctor3 =
  "/assets/aboutUs/100077_(Abdullah-Al-Fahad).jpg";
export const AssistantProctor4 = "/assets/aboutUs/Naziba_Arts.jpg";
export const VCSir = "/assets/aboutUs/VCSir.webp";
export const Chairman = "/assets/aboutUs/chairmanEasternUniversity.webp";
export const ChairmanName = "Mr. Md. Maniruzzaman Molla";
export const worcester =
  "/assets/aboutUs/InternationalAcademicCollaboration/Worcester.jpg";
export const LPC = "/assets/aboutUs/InternationalAcademicCollaboration/LPC.jpg";
export const Salford =
  "/assets/aboutUs/InternationalAcademicCollaboration/Salford.jpg";
export const Frank =
  "/assets/aboutUs/InternationalAcademicCollaboration/Frank.jpg";
export const UniMAP =
  "/assets/aboutUs/InternationalAcademicCollaboration/UniMAP.jpg";
export const State_University_of_New_York_seal =
  "/assets/aboutUs/InternationalAcademicCollaboration/State_University_of_New_York_seal.png";
export const cambridgeInternationalCollege =
  "/assets/aboutUs/InternationalAcademicCollaboration/cambridgeInternationalCollege.jpg";
export const AIS = "/assets/aboutUs/InternationalAcademicCollaboration/AIS.jpg";
export const AIT = "/assets/aboutUs/InternationalAcademicCollaboration/AIT.jpg";
export const msu = "/assets/aboutUs/InternationalAcademicCollaboration/msu.jpg";
export const TNI_logo =
  "/assets/aboutUs/InternationalAcademicCollaboration/TNI_logo.jpg";
export const UITM =
  "/assets/aboutUs/InternationalAcademicCollaboration/UITM.jpg";
export const UUM = "/assets/aboutUs/InternationalAcademicCollaboration/UUM.jpg";
export const putra =
  "/assets/aboutUs/InternationalAcademicCollaboration/putra.png";
export const YUNNAN =
  "/assets/aboutUs/InternationalAcademicCollaboration/YUNNAN.jpg";
export const ynvtc =
  "/assets/aboutUs/InternationalAcademicCollaboration/ynvtc.jpg";
export const YNU = "/assets/aboutUs/InternationalAcademicCollaboration/YNU.jpg";
export const HZNU_logo =
  "/assets/aboutUs/InternationalAcademicCollaboration/HZNU_logo.png";
export const TA = "/assets/aboutUs/InternationalAcademicCollaboration/TA.jpg";
export const president = "/assets/aboutUs/president.webp";
export const ActingTreasurerAbbasAli =
  "/assets/aboutUs/ActingTreasurarAbbasAli.jpg";
export const ExamControllerKhaledVai =
  "/assets/aboutUs/ExamControllerKhaledVai.jpg";

export const Crown =
  "/assets/aboutUs/InternationalAcademicCollaboration/Crown-Institute-of-Higher-Education_-Australia.webp";
export const othello =
  "/assets/aboutUs/InternationalAcademicCollaboration/Othello.webp";

// Administration
export const DeputyRegistrar = "/assets/Admins/Office_New/FaridHossainN.jpg";
export const DeputyRegistrarPermanentCampus =
  "/assets/Admins/Office_New/HarunPC.jpg";
export const DeputyRegistrarHRSection =
  "/assets/Admins/Office_New/HR_Nafiun.jpg";

export const AdmissionDirector = "Ms. Nazla Fatmi";
export const DirectorAdmissionOffice =
  "/assets/Admins/Office_New/NazlaArts.jpg";
export const AdmissionDirectorMail = "nazla@easternuni.edu.bd";
export const AdmissionDirectorDesignation = "Director and Assistant Professor";

export const DirectorPROffice = "/assets/Admins/Office_New/FatemiSirPR.jpg";

export const DirectorCSIOOffice = "Mr. Forhad Hossain";
export const DirectorCSIOOfficeDesignation = "Assistant Director";
export const DirectorCSIOOfficeMail = "csio@easternuni.edu.bd";
export const DirectorCSIOOfficeIMG =
  "/assets/Admins/Office_New/200226_ForhadHossain.webp";

export const DeputyDirectorITOffice =
  "/assets/Admins/Office_New/Md. Abdullah Al Mamun.jpg";
export const InChargeOSA =
  "/assets/Admins/Office_New/200226_ForhadHossain.webp";
export const DeputyDirectorAccountOffice =
  "/assets/Admins/Office_New/AbdulKarim.jpg";
export const DeputyDirectorInternalAuditOffice =
  "/assets/Admins/Office_New/MaksudAuditAD.jpg";
export const AssistantDirectorLogistics =
  "/assets/Admins/Office_New/Monjur.jpg";

export const Librarian = "Mr. Kumar Bishwajit Das";
export const LibrarianDesignation = "Deputy Librarian";
export const LibrarianMail = "bishwajit@easternuni.edu.bd";
export const LibrarianIMG =
  "/assets/Admins/Office_New/200225_KumarBishwajitDas.webp";

//Academic page
export const studentloginPageImg = "/assets/academic/studentloginPage.jpg";
export const StudentHomePage = "/assets/academic/StudentHomePage.jpg";
export const OnlinePay = "/assets/academic/OnlinePay.jpg";
export const OnlinePay1 = "/assets/academic/OnlinePay1.jpg";
export const feePage = "/assets/academic/feePage.jpg";
export const PayNow = "/assets/academic/PayNow.jpg";
export const Medium = "/assets/academic/Medium.jpg";
export const bkash = "/assets/academic/7_bkash.jpg";
export const bkash8 = "/assets/academic/8_Bkash.jpg";
export const Bkashpin = "/assets/academic/9_Bkash pin.jpg";
export const VisaCardPayment = "/assets/academic/11VisaCardPayment.jpg";
export const RocketPayment = "/assets/academic/12RocketPayment.jpg";
export const ledger = "/assets/academic/ledger.jpg";

// CRD
export const crdDirector =
  "/assets/CRD/100070_Prof._Dr._Md._Abbas_Ali_Khan_gyPkRuA.jpg";
export const crdMember =
  "/assets/CRD/130003_Dr._Md._Mahfuzur_Rahman_orsCpy9.jpg";
export const CRDSecretary = "/assets/CRD/200045_Mustakim_Parvez_0XdyW85.jpg";

//Campus
export const hostel1 = "/assets/Campus/hostel_1.webp";
export const hostel2 = "/assets/Campus/hostel_2.webp";

// IQAC
export const IQACDirector = "/assets/IQAC/IQACDirectorDrMdAshrafHossain.jpg";
export const IQACOrganogram = "/assets/IQAC/IQACOrganogra_24042018.jpg";
export const IQACPresentaionQualityAssuaranceSystem =
  "/assets/IQAC/IQACPresentaionQualityAssuranceSystems.pptx";
export const IQACPresentaionSelfAssessmentWorkshopSAC2015October292 =
  "/assets/IQAC/IQACPresentationSelf-AssessmentWorkshop-SAC2015-October29-2.pptx";
export const IQACPresentaionSelfAssessmentProgramLavel1 =
  "/assets/IQAC/IQACPresentationSelf-Assessmentat rogramLevel-1.ppt";
export const IQACPresentaionAssuranceofLearningAUMCollegeofBusiness =
  "/assets/IQAC/IQACPresentationAssuranceofLearningAUMCollegeofBusiness.pptx";
export const IQACPresentationProfessionalDevelopmentProgramMahboobAliAIT =
  "/assets/IQAC/IQACPresentationProfessionalDevelopmentProgramMahboobAli-AIT.pptx";
export const IQACPresentationWorkshoponSACResponsibilitiesSAC2015October29 =
  "/assets/IQAC/IQACPresentationWorkshoponSACResponsibilitiesSAC2015October29.pptx";
export const IQACPresentationSelfAssessmentatProgramLevel2 =
  "/assets/IQAC/IQACPresentationSelfAssessmentatProgramLevel2.pptx";
export const IQACPresentationQualityAssuranceSystemPPbyDrMesbahuddin =
  "/assets/IQAC/IQACPresentationQualityAssuranceSystemPPbyDrMesbahuddin.pptx";
export const IQACPresentationQualityCurriculumDevelopmentProcess =
  "/assets/IQAC/IQACPresentationQualityCurriculumDevelopmentProcess.pptx";
export const IQACPresentationASSESSMENTFORIMPROVINGSTUDENTLEARNING =
  "/assets/IQAC/IQACPresentationASSESSMENTFORIMPROVINGSTUDENTLEARNING.pptx";
export const IQACPresentationOrientationworkshopatUGCbyAdhikary =
  "/assets/IQAC/IQACPresentationOrientationworkshopatUGCbyAdhikary.pptx";
export const IQACPresentationIQACProposalwritingRound2 =
  "/assets/IQAC/IQACPresentationIQACProposalwritingRound2.pptx";
export const IQACPresentationPreparationofBudget =
  "/assets/IQAC/IQACPresentationPreparationofBudget.ppt";
export const IQACPresentationWorkshoponSACProcess =
  "/assets/IQAC/IQACPresentationWorkshoponSACProcess.pptx";
export const IQACPresentationWorkshoponSACResponsibilitiesSAC2015 =
  "/assets/IQAC/IQACPresentationWorkshoponSACResponsibilitiesSAC2015.pptx";
export const IQACPresentationConductingSurvey =
  "/assets/IQAC/IQACPresentationConductingSurvey.pptx";
export const IQACPresentationIQACSA =
  "/assets/IQAC/IQACPresentationIQACSA.pptx";
export const IQACPresentationPresentation1SAC2015October292 =
  "/assets/IQAC/IQACPresentationPresentation1SAC2015October292.pptx";
export const IQACPresentationSurveyPresentation =
  "/assets/IQAC/IQACPresentationSurveyPresentation.pptx";

export const IQACDocumentsCourseSpecification =
  "/assets/IQAC/IQACDocumentsCourseSpecification-1.docx";
export const IQACDocumentsCourseSpecification2 =
  "/assets/IQAC/IQACDocumentsCourseSpecification-2.docx";
export const IQACDocumentsFieldExperienceSpecification =
  "/assets/IQAC/IQACDocumentsFieldExperienceSpecification.docx";
export const IQACDocumentsIQACtotalFund =
  "/assets/IQAC/IQACDocumentsIQACtotalFund.JPG";
export const IQACDocumentsPrivateUniversityAct2010 =
  "/assets/IQAC/IQACDocumentsPrivateUniversityAct2010.pdf";
export const IQACDocumentsTeacherPerformanceform =
  "/assets/IQAC/IQACDocumentsTeacherPerformanceform.docx";
export const IQACDocumentsSAReport = "/assets/IQAC/IQACDocumentsSAReport.doc";

export const IQACAdditionalDirector =
  "/assets/IQAC/130045_Dr._Iqbal_Mahmud_TBW6YPd.jpg";
export const IQACSectionOfficer = "/assets/IQAC/200227_Md._Asraf.jpg";
export const IQACItOfficer = "/assets/IQAC/200210_Mr._Firoj_Alam.webp";

//Admission
export const tutionFeeImage = "/assets/admission/tutionFeeImage.webp";
export const foreignStudentTutionFeeImage =
  "/assets/admission/ForeignStudentTutionFeeImage.webp";
export const transportFacilitiesInfoAboutRouteImage =
  "/assets/admission/TransportFacilitiesInfoAboutRoute.webp";
export const admissionRelatedInformation =
  "/assets/admission/admissionRelatedInformation.webp";
export const AdmissionForm = "/assets/admission/Admission Form.pdf";
export const bKashPayment = "/assets/admission/bkashPayment.webp";
export const CreditTransferFrom =
  "/assets/admission/Credt Transfer Form of EU.pdf";

export const admissionFair = "/assets/admission/admissionFair.webp";

//Pop up modal of admission for Home page
export const admissionModal = "/assets/admission/popup.gif";

// CSIO CV
export const SampleCV1 = "/assets/CSIOCV/SampleCV1.docx";
export const SampleCV2 = "/assets/CSIOCV/SampleCV2.docx";

// faculty of Engineering
export const deanImgEngineering = "/assets/Faculty/engineeringDean.jpg";
export const CharipersonCSE = "assets/Faculty/ChairpersonCSEMilonSir.jpg";
export const ChairpersonEEE = "assets/Faculty/Chairperson_EEERabbani.jpg";
export const facultyImgEngineering = "/assets/cse.jpg";
export const cseSliderimg1 = "/assets/slider/Pc/CSESliderImg-1.JPG";
export const cseSliderimg2 = "/assets/slider/Pc/CSE SliderImg-2.JPG";
export const cseSliderimg3 = "/assets/slider/Pc/CSE SliderImg-3.JPG";
export const cseSliderimg4 = "/assets/slider/Pc/CSE SliderImg-4.JPG";
export const cseSliderimg5 = "/assets/slider/Pc/CSE SliderImg-5.JPG";
export const cseSliderimg6 = "/assets/slider/Pc/CSE SliderImg-6.JPG";
export const cseSliderimg7 = "/assets/slider/Pc/CSE SliderImg-7.JPG";
export const engDeptImg = "/assets/engDept.jpg";
export const CSECourseDistridution = "assets/Faculty/CSE.pdf";
export const EEECourseDistridution = "assets/Faculty/EEE.pdf";
export const engFacultyTestImg = "/assets/testFaculty.jpg";
export const CSEDeptImg = "/assets/CSEDept.jpg";
export const EEEDeptImg = "/assets/EEEDept.jpg";
export const CivilDeptImg = "/assets/CivilEngineer.webp";

// faculty of Busness Administration
export const facultyImgBusness = "/assets/aboutUs/FacultyOfArts.jpg";
export const deanImgBusness =
  "/assets/Faculty/DeanofBisnessAdministrationAbbasAli.jpg";
export const chairpersonImgBusiness =
  "/assets/Faculty/Chairperson_HabibAnwar_Business.jpg";
export const BusnessSlderimg1 =
  "/assets/slider/Pc/FacultyOfBusinessSliderImage-1.JPG";
export const BusnessSlderimg2 =
  "/assets/slider/Pc/FacultyOfBusinessSliderImage-2.webp";
export const BusnessSlderimg3 =
  "/assets/slider/Pc/FacultyOfBusinessSliderImage-3.JPG";
export const BusnessSlderimg4 =
  "/assets/slider/Pc/FacultyOfBusinessSliderImage-4.jpg";
export const BusnessSlderimg5 =
  "/assets/slider/Pc/FacultyOfBusinessSliderImage-5.JPG";
export const BusnessSlderimg6 =
  "/assets/slider/Pc/FacultyOfBusinessSliderImage-6.JPG";
export const BusnessSlderimg7 =
  "/assets/slider/Pc/FacultyOfBusinessSliderImage-7.webp";
export const Busnessimg = "/assets/bbaDept.jpg";
export const islamicFinanceBBA =
  "/assets/slider/Pc/Bachelor-of-Business-Administration-_BBA_-in-IFBI-webslide.1.webp";
export const islamicFinanceMBA =
  "/assets/slider/Pc/Bachelor-of-Business-Administration-_BBA_-in-IFBI-webslide.2.webp";

// faculty of Arts
export const deanImgArts = "/assets/Faculty/DeanOfEnglishMoniruzzamanArts.jpg";
export const facultyImgArts = "/assets/FacultyOfArts.jpg";
export const ArtsSliderimg1 =
  "/assets/slider/Pc/facultyOfArtsSliderImage-1.JPG";
export const ArtsSliderimg2 =
  "/assets/slider/Pc/facultyOfArtsSliderImage-2.JPG";
export const ArtsSliderimg3 =
  "/assets/slider/Pc/facultyOfArtsSliderImage-3.JPG";
export const ArtsSliderimg4 =
  "/assets/slider/Pc/facultyOfArtsSliderImage-4.JPG";
export const ArtsSliderimg5 =
  "/assets/slider/Pc/facultyOfArtsSliderImage-5.JPG";
export const ArtsSliderimg6 =
  "/assets/slider/Pc/facultyOfArtsSliderImage-6.JPG";
export const ArtsSliderimg7 =
  "/assets/slider/Pc/facultyOfArtsSliderImage-7.JPG";
export const englishImg = "/assets/englishDept.jpg";

// faculty of Law

export const deanImgLaw = "/assets/Faculty/ChairpersonABMImdadulLaw.jpg";
export const facultyImgLaw = "/assets/LLB---.jpg";
export const LawSliderimg1 = "/assets/slider/Pc/FacultyOfLawSliderImage-1.jpg";
export const LawSliderimg2 = "/assets/slider/Pc/FacultyOfLawSliderImage-2.JPG";
export const LawSliderimg3 = "/assets/slider/Pc/FacultyOfLawSliderImage-3.JPG";
export const LawSliderimg4 = "/assets/slider/Pc/FacultyOfLawSliderImage-4.jpg";
export const LawSliderimg5 = "/assets/slider/Pc/FacultyOfLawSliderImage-5.jpeg";
export const LawSliderimg6 = "/assets/slider/Pc/FacultyOfLawSliderImage-6.jpg";
export const LawSliderimg7 = "/assets/slider/Pc/FacultyOfLawSliderImage-7.JPG";
export const LawImg = "/assets/lawDept.jpg";
export const LLBCourseDistribution =
  "/assets/Faculty/Course_Distributuion_LLB.pdf";
export const LLMCourseDistribution = "/assets/Faculty/LLM.png";

// Faculty of Life Sicence
export const lifeScinceImg = "/assets/LifeScienceImg.webp";
export const ChairmanPharmacyImg = "/assets/Faculty/chairpersonPharmacy.webp";
export const pharmacyImg = "/assets/PharmaceuticalLab.webp";
export const PharmacySliderImg1 = "/assets/slider/Pc/Pharmacy-1.webp";
export const PharmacySliderImg2 = "/assets/slider/Pc/Pharmacy-2.webp";
export const PharmacySliderImg3 = "/assets/slider/Pc/Pharmacy-3.webp";
export const PharmacySliderImg4 = "/assets/slider/Pc/Pharmacy-4.webp";
export const PharmacySliderImg5 = "/assets/slider/Pc/Pharmacy-5.webp";
export const PharmacyCouseDistridution =
  "/assets/Faculty/PharmacyCouseDistridution.pdf";

//Department of English
export const chairPersonImgArts =
  "/assets/Faculty/ChairpersonRowshonAra_Arts.jpg";
export const BAEnglishCourseDistribution = "/assets/Faculty/BAinEnglish.pdf";
export const MAEnglishCourseDistribution = "/assets/Faculty/MA Syllabus.pdf";

//Department of Business
export const chairPersonImgBus =
  "/assets/Faculty/Chairperson_HabibAnwar_Business.jpg";
export const BBABrochure = "assets/Faculty/BBABrochure.pdf";
export const BBACourseDistridution = "assets/Faculty/BBA_Curriculum.pdf";
export const MBACourseDistridution = "assets/Faculty/MBA.pdf";
export const LabBBA = "assets/image/Labs/Lab_Facilities_Business_admin.JPG";
export const BBAIslamCourseDistridution =
  "assets/Faculty/Brocheure_BBA_Islamic.pdf";
export const MBAIslamCourseDistridution =
  "assets/Faculty/Brocheure_MBA_Islamic.pdf";

//Department of cse
export const chairPersonImgCSE = "/assets/Faculty/ChairpersonCSEMilonSir.jpg";
export const facultyImgCSE = "/assets/img/cse.jpg";

//Department of Civil
export const CivilSliderimg1 = "/assets/slider/Pc/Civil-1.webp";
export const CivilSliderimg2 = "/assets/slider/Pc/Civil-2.webp";
export const CivilSliderimg3 = "/assets/slider/Pc/Civil-3.webp";
export const chairPersonImgCivil = "/assets/Faculty/ChairpersonCivil.webp";
export const CivilSliderimg4 = "/assets/slider/Pc/CivilSliderImg4.webp";
export const CivilSliderimg5 = "/assets/slider/Pc/CivilSliderImg5.webp";

export const civilCouseDistridution =
  "/assets/Faculty/CourseDistributonCivil.pdf";
export const cgpaCalculation = "/assets/Faculty/CGPA_CALCULATION.png";

export const foundation2023 =
  "/assets/Faculty/Civil_Engineering_Foundation_2023.pdf";
export const foundation2024 =
  "/assets/Faculty/Civil_Engineering_Foundation_2024.pdf";

//Department of EEE
export const EEESliderimg1 = "/assets/slider/Pc/DeptOfEEESliderImg-1.JPG";
export const EEESliderimg2 = "/assets/slider/Pc/DeptOfEEESliderImg-2.jpg";
export const EEESliderimg3 = "/assets/slider/Pc/DeptOfEEESliderImg-3.JPG";
export const EEESliderimg4 = "/assets/slider/Pc/DeptOfEEESliderImg-4.JPG";
export const EEESliderimg5 = "/assets/slider/Pc/DeptOfEEESliderImg-5.JPG";
export const EEESliderimg6 = "/assets/slider/Pc/DeptOfEEESliderImg-6.JPG";
export const EEESliderimg7 = "/assets/slider/Pc/DeptOfEEESliderImg-7.jpg";
export const chairPersonImgEEE = "/assets/Faculty/RabbaniChairperson_EEE.jpg";
export const facultyImgEEE = "/assets/EEE---.jpg";

// Department of Law
export const chairpersonImgLaw = "/assets/Faculty/ChairpersonABMImdadulLaw.jpg";

// Forms

export const Administrative_Position_EU_Career =
  "/assets/Forms/Administrative Position_EU_Career.doc";
export const Faculty_Position_EU_Career =
  "/assets/Forms/Faculty Position_EU_Career.doc";

export const On_campus_job_Form = "/assets/Forms/On_campus_job_Form.doc";

export const Messenger =
  "/assets/Forms/oss_form_Messenger_Driver_Electrician_ Gardener.doc";

//Online Payment Instraction
export const StudentLoginPage_1 =
  "/assets/paymentInstraction/1_StudentLoginPage.jpg";
export const StudentHomePage_2 =
  "/assets/paymentInstraction/2_StudentHomePage.jpg";
export const StudentInformationPage_3 =
  "/assets/paymentInstraction/3_StudentInformationPage.jpg";
export const StudentYearSemesterPage_4 =
  "/assets/paymentInstraction/4_StudentYearSemesterPage.jpg";
export const StudentPaymentPage_5 =
  "/assets/paymentInstraction/5_StudentPaymentPage.jpg";
export const StudentPayNowPage_6 =
  "/assets/paymentInstraction/6_StudentPayNowPage.jpg";

//bkash
export const bkash_1 = "/assets/paymentInstraction/1_Bkash.jpg";
export const bkash_2 = "/assets/paymentInstraction/2_Bkash.jpg";
export const bkash_3 = "/assets/paymentInstraction/3_Bkash.jpg";

//nagad
export const nagad_1 = "/assets/paymentInstraction/1_Nagad.jpg";
export const nagad_2 = "/assets/paymentInstraction/2_Nagad.jpg";
export const nagad_3 = "/assets/paymentInstraction/3_Nagad.jpg";

//rocket
export const rocket_1 = "/assets/paymentInstraction/1_rocket.jpg";

//card
export const card_1 = "/assets/paymentInstraction/1_card.jpg";

//ssl
export const ssl_1 = "/assets/paymentInstraction/1_SSL.jpg";

//Messages

export const artsDean =
  "Welcome to the Department of English. Our faculty and staff members are dedicated to ensure your success in academic achievement and in your career. We offer core courses in English and World literature as well as academic writing, professional writing, linguistics and ELT. Our programs in English will give you a strong multidimensional foundation for exceling in nearly any career. We offer courses to enhance critical thinking and analytical ability in all kinds of subjects. Computer and ICT are also integral to our program. Our writing courses encompass various issues from both the print and electronic communication. Moreover, the linguistics and ELT courses pave the way of the teacher-learners for their future career. In today's world academic excellence is paired with cocurricular activities such as debate, theater, music, public speaking and many more.Through different curricular and co-curricular activities, mentoring the young minds has been a signal feature of the department. An English degree tells the world that you are a flexible thinker who not only have the mastery over the four skills in English but also have the research skills to find answers and solve problems of any sort. Whatever your aspirations, you will graduate from our English program with a world-class education and the confidence of knowing you are ready for the challenges ahead in your life. But, perhaps more than ever, in the time of Covid, we need social and intellectual connection and we have been doing a great deal toward accomplishing that.We are constantly in touch with our students across the country and are providing all the mental and academic support to them.  Besides providing the academic care, all our faculty members and staffs from the Department have been quite active throughout this stressful time of pandemic to stretch out their all-out effort to provide psychological boosting to the students so that their academic progress does not hamper. The Department has successfully addressed the ongoing needs of remote instruction, social distancing, and health safety of all concerned. We have a long history of promoting our faculty members and students. We have several faculty members in our Department who are published writers and researchers.A number of project works are on-going right now in the Department. Our students are also publishing in different platforms and are proving themselves as budding writers of the country. It has been quite inspiring and happening to see how we have dealt with the extraordinary challenges that the year 2020 has posed. Thus, the Department of English is eager to work with all the fresh young minds out there waiting to commence their journey of higher education as we continue to meet them with resourcefulness, imagination and good will.";

export const noImage = "/assets/noImage.webp";

export const fileSource = "/assets/videos/7th_Convocation.mp4";

export const conferenceBBA =
  "/assets/conference/National-Conference-FBA-2024-2.webp";
export const conferenceLaw = "/assets/conference/SAPLAW_Conference_2023.webp";
export const conferenceLawInstrection =
  "/assets/conference/SOUTH_ASIAN_POSTGRADUATE_LAW_CONFERENCE_2023.pdf";
